// Auth
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_SET_LAST_ACTIVE_TIME = 'AUTH_SET_LAST_ACTIVE_TIME';
export const AUTH_SET_JUST_LOGGED_IN = 'AUTH_SET_JUST_LOGGED_IN';

// Layout
export const SET_MODE = 'SET_MODE';
export const CHECK_MODE = 'CHECK_MODE';

//Loading
export const ADD = 'ADD';
export const MINUS = 'MINUS';
export const SET_LOADING = 'SET_LOADING';

//lang
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

//setting
export const SET_SETTING = 'SET_SETTING';
